<form class="lp-collection-edit" [formGroup]="form">
  <div class="lp-collection-edit__block">
    <div [ngClass]="isMobile ? 'text_size-m text_bold' : 'text_heading-5'">
      {{ 'components.lpCollectionEdit.labels.basicInfoTitle' | translate }}
    </div>

    <app-field-wrapper
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [size]="tuiElementMediumSize"
      [text]="'components.lpCollectionEdit.fields.status' | translate"
    >
      <app-toggle tabindex="1" [size]="'m'" formControlName="status"></app-toggle>
    </app-field-wrapper>

    <tui-input
      tuiAutoFocus
      tabindex="2"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      formControlName="title"
      [tuiTextfieldSize]="tuiElementLargeSize"
    >
      {{ 'components.lpCollectionEdit.fields.title' | translate }}
      <span class="tui-required"></span>
    </tui-input>

    <tui-input-date
      tabindex="4"
      formControlName="validTill"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [tuiTextfieldSize]="tuiElementLargeSize"
    >
      {{ 'components.lpCollectionEdit.fields.validTill' | translate }}
    </tui-input-date>

    <tui-input-number
      tabindex="5"
      formControlName="sortOrder"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [tuiTextfieldSize]="tuiElementLargeSize"
    >
      {{ 'components.lpCollectionEdit.fields.sortOrder' | translate }}
      <span class="tui-required"></span>
    </tui-input-number>
  </div>

  <div class="lp-collection-edit__block">
    <div [ngClass]="isMobile ? 'text_size-m text_bold' : 'text_heading-5'">
      {{ 'components.lpCollectionEdit.labels.pushInfoTitle' | translate }}
    </div>

    <tui-input
      tabindex="7"
      formControlName="pushTitle"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [tuiTextfieldSize]="tuiElementLargeSize"
    >
      {{ 'components.lpCollectionEdit.fields.pushTitle' | translate }}
    </tui-input>

    <tui-input
      tabindex="8"
      formControlName="pushText"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [tuiTextfieldSize]="tuiElementLargeSize"
    >
      {{ 'components.lpCollectionEdit.fields.pushText' | translate }}
    </tui-input>

    <div tuiGroup>
      <tui-input-date
        tabindex="9"
        formControlName="pushSendOnDay"
        [class.tui-skeleton]="loading"
        [class.tui-skeleton_text]="loading"
        [tuiTextfieldSize]="tuiElementLargeSize"
        [tuiTextfieldCleaner]="true"
      >
        {{ 'components.lpCollectionEdit.fields.pushSendOnDay' | translate }}
      </tui-input-date>

      <tui-input-time
        tabindex="10"
        formControlName="pushSendOnTime"
        [tuiDropdownMobile]="'common.fields.timePlaceholder' | translate"
        [class.tui-skeleton]="loading"
        [class.tui-skeleton_text]="loading"
        [tuiTextfieldSize]="tuiElementLargeSize"
        [items]="timeItems"
        [tuiTextfieldCleaner]="true"
      >
        {{ 'components.lpCollectionEdit.fields.pushSendOnTime' | translate }}
      </tui-input-time>
    </div>

    <app-field-wrapper
      *ngIf="mode === 'edit'"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [text]="'components.lpCollectionEdit.labels.pushCheck' | translate"
      [size]="tuiElementMediumSize"
    >
      <button tuiButton type="button" class="button" tabindex="11" size="xs" (click)="checkPush.emit()">
        <span class="button__label">
          {{ 'common.buttons.check' | translate }}
        </span>
      </button>
    </app-field-wrapper>
  </div>

  <div class="lp-collection-edit__block">
    <div [ngClass]="isMobile ? 'text_size-m text_bold' : 'text_heading-5'">
      {{ 'components.lpCollectionEdit.labels.bannerInfoTitle' | translate }}
    </div>

    <tui-input
      tabindex="12"
      formControlName="bannerTitle"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [tuiTextfieldSize]="tuiElementLargeSize"
    >
      {{ 'components.lpCollectionEdit.fields.bannerTitle' | translate }}
    </tui-input>

    <app-input-files
      tabindex="13"
      formControlName="bannerBackground"
      accept="image/*"
      [label]="' '"
      [link]="'components.lpCollectionEdit.fields.bannerBackground' | translate"
      [loading]="loading"
      [size]="tuiElementLargeSize"
      [maxFileSize]="maxDocFileSize"
    ></app-input-files>

    <div
      class="lp-collection-edit__preview"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [tuiTextfieldSize]="tuiElementLargeSize"
      [tuiTextfieldCleaner]="true"
    >
      <lp-category-cell [category]="banner" [readonly]="true" [withBackground]="true"></lp-category-cell>
    </div>
  </div>

  <ng-container class="lp-collection-edit__block" formArrayName="sections">
    <div
      *ngFor="let sectionControl of sectionsControl.controls; let sectionIndex = index"
      class="lp-collection-edit__block"
    >
      <ng-container [formGroupName]="sectionIndex">
        <div class="section-header">
          <div [ngClass]="isMobile ? 'text_size-m text_bold' : 'text_heading-5'">Раздел {{ sectionIndex + 1 }}</div>
          <div class="buttons">
            <button
              tuiIconButton
              type="button"
              iconStart="@tui.chevron-up"
              appearance="outline-grayscale"
              tuiAppearanceMode="checked"
              [size]="'m'"
              [disabled]="sectionIndex === 0"
              (click)="moveSection(sectionIndex, -1)"
            ></button>

            <button
              tuiIconButton
              type="button"
              iconStart="@tui.chevron-down"
              appearance="outline-grayscale"
              tuiAppearanceMode="checked"
              [size]="'m'"
              [disabled]="sectionIndex === sectionsControl.controls.length - 1"
              (click)="moveSection(sectionIndex, 1)"
            ></button>

            <button
              tuiIconButton
              type="button"
              iconStart="@tui.trash-2"
              appearance="outline-grayscale"
              tuiAppearanceMode="checked"
              [size]="'m'"
              (click)="removeSection(sectionIndex)"
            ></button>
          </div>
        </div>

        <app-editor-field
          tabindex="3"
          formControlName="contentText"
          [excludeTools]="excludeEditorTools"
          [placeholder]="'components.lpCollectionEdit.fields.contentText' | translate"
          [class.tui-skeleton]="loading"
          [class.tui-skeleton_text]="loading"
        ></app-editor-field>

        <lp-search-products-input
          tabindex="6"
          formControlName="products"
          [label]="'components.lpCollectionEdit.labels.productsFew' | translate"
          [class.tui-skeleton]="loading"
          [class.tui-skeleton_text]="loading"
          [tuiTextfieldSize]="tuiElementLargeSize"
          [tuiTextfieldCleaner]="true"
          [pluralize]="[
            'components.lpCollectionEdit.labels.productsOne' | translate,
            'components.lpCollectionEdit.labels.productsFew' | translate,
            'components.lpCollectionEdit.labels.productsMany' | translate,
          ]"
          [textfieldSize]="tuiElementLargeSize"
        ></lp-search-products-input>
      </ng-container>
    </div>

    <div tuiGroup class="add-button" [collapsed]="true">
      <button
        tuiButton
        appearance="outline-grayscale"
        tuiAppearanceMode="checked"
        [size]="'m'"
        type="button"
        (click)="addSection()"
      >
        {{ 'components.lpCollectionEdit.buttons.addSection' | translate }}
      </button>

      <button
        tuiIconButton
        class="tui-group__auto-width-item"
        appearance="outline-grayscale"
        tuiAppearanceMode="checked"
        iconStart="@tui.circle-plus"
        [size]="'m'"
        type="button"
        (click)="addSection()"
      ></button>
    </div>
  </ng-container>

  <div *ngIf="!loading" class="lp-collection-edit__buttons">
    <button
      tuiButton
      tabindex="14"
      type="button"
      appearance="primary"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [size]="tuiElementLargeSize"
      (click)="onClickSaveButton()"
    >
      {{ 'common.buttons.save' | translate }}
    </button>

    <button
      tuiButton
      tabindex="15"
      type="button"
      appearance="secondary"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [size]="tuiElementLargeSize"
      (click)="cancelEdit.emit()"
    >
      {{ 'common.buttons.cancel' | translate }}
    </button>
  </div>
</form>
